/**
 * Site script: the header's scrolled state, and where the mobile drawer
 * starts (just under the header, whatever sits above it: utility bar, WP
 * admin bar). The menu toggle itself is GenerateBlocks Pro's Navigation
 * block; the group finder lives in finder.js.
 */
(() => {
  const header = document.querySelector('.rdpm-header');
  if (!header) {
    return;
  }

  const update = () => {
    header.classList.toggle('is-stuck', window.scrollY > 8);
    document.documentElement.style.setProperty('--rdpm-drawer-top', `${Math.round(header.getBoundingClientRect().bottom)}px`);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  header.addEventListener('click', update);
})();
